"use client";
import {useState} from "react";
import {apiBaseUrl, mediaUrl} from "@/lib/config/app";
import {getShopConfig} from "@/server/shop/get-shop-config";
import Link from "next/link";
import Image from "next/image";
import PureHtml from "@/components/custom/PureHtml";
import {Button} from "@mantine/core";

export default function BlogList({initialBlogs, currentPage, lastPage}){
    const nshop = getShopConfig();
    const [blogs, setBlogs] = useState(initialBlogs);
    const [page, setPage] = useState(currentPage);
    const [loading, setLoading] = useState(false);
    const loadMore = async () => {
        const nextPage = page + 1;
        setLoading(true);
        try {
            const response = await fetch(`/api/blogs/all-blogs?page=${nextPage}`);
            const data = await response.json();
            const blogsData = data.blogs;
            setBlogs(prev => [...prev, ...blogsData.data]);
            setPage(nextPage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-4">
                {blogs?.map(blog => {
                    const blogAltText = blog?.featured_image_alt || blog?.blog_title;
                    return (
                        <article key={blog.blog_id} className={'h-full'}>
                            <Link href={`/blogs/${blog.blog_slug}`} title={blog.title}>
                                <div className={'shadow rounded bg-white border border-gray-100 overflow-hidden h-full'}>
                                    <div className={'relative w-full h-auto min-h-80 max-h-80 overflow-hidden'}>
                                        <Image
                                            fill
                                            src={`${mediaUrl}${blog.blog_image || 'noimage.png'}`}
                                            alt={blogAltText} sizes={'50vw'}
                                            className={'rounded-top object-cover'} />
                                    </div>
                                    <div className={'p-2'}>
                                        <h2 className={'text-xl lg:text-2xl line-clamp-1 mt-2'}>{blog.blog_title}</h2>
                                        <PureHtml html={blog?.blog_excerpt}/>
                                        <Button size={'sm'} maw={150}>Read More</Button>
                                    </div>
                                </div>
                            </Link>
                        </article>
                    )
                })}
            </div>
            <div className={'flex justify-center py-4'}>
                {page < lastPage && (
                    <Button
                        onClick={loadMore}
                        disabled={loading}
                    >
                        {loading ? "Loading..." : "Load More Blogs"}
                    </Button>
                )}
            </div>
        </>
    )

}